module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-item",
    class: {
      'is-selected': _vm.isSelected,
      'has-children': _vm.hasChildren,
      'has-path': _vm.hasPath,
      'has-description': _vm.titleAttribute,
      'cursor-disabled': _vm.isLocked
    },
    attrs: {
      "title": _vm.titleAttribute
    }
  }, [(_vm.path) ? _c('small-text', [_vm._v(_vm._s(_vm.path))]) : _vm._e(), _vm._v(" "), _c('span', {
    ref: "name"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.titleAttribute) ? _c('svg-icon', {
    staticClass: "panel-item__copy",
    attrs: {
      "icon": _vm.copy,
      "width": 13,
      "height": 13,
      "preserveAspectRatio": "xMinYMid meet"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.copyDescription.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasChildren) ? _c('svg-icon', {
    staticClass: "panel-item__arrow",
    attrs: {
      "icon": _vm.arrow,
      "width": 8,
      "height": 13
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-233479cc","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/workbench/attributePanel/components/PanelItem.vue
// module id = 2020
// module chunks = 0